import {
    ADD_USER_SUCCESS,
    ADD_USER_ERROR
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case ADD_USER_SUCCESS:
          return {
            ...state,
            newAdminData: action.payload,
          };
        case ADD_USER_ERROR:
          return {
            ...state,
            newAdminError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    